import React from 'react'

// Import styled components
import { Wrapper, ContactDesc, StartedBtn } from './ContactResponsive'

const Contact = (props) => (
  <Wrapper>
    <ContactDesc type='xxSmall' text='Have an idea?' />
    <StartedBtn
      text='Start Your Agility Experience'
      type='info'
      onPress={props.handleToggleModal}
    />
  </Wrapper>
)

export default Contact



// WEBPACK FOOTER //
// ./src/components/sections/contact/Contact.js